import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'
// 加入购物车
export function getshopcar(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/shopping/saveShoppingCart',
    method: 'post',
    data
  })
}

// 我的关注
export function getcollect(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/attention',
    method: 'get',
    params
  })
}

// 收藏
export function getattentionlist(params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/parts/listAttention',
    method: 'get',
    params
  })
}

// 立即购买(前台)
export function getpurchase(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/orders/parts/prebuy',
    // url: 'http://192.168.0.108:5000/wss-order/orders/parts/prebuy',
    method: 'post',
    data
  })
}
